import { z } from 'zod'

export const geoAddressSchema = z.object({
  address: z.string(),
  name: z.string(),
  lat: z.string(),
  lng: z.string(),
  isFavorite: z.boolean()
})
